export default function Banner() {
  return (
    <div className="bg-indigo-500 text-center py-2 absolute top-0 w-full text-white font-semibold">
      <h3>Now live on the App Store!</h3>
    </div>
  );
}
